const versionUpdate = {
  title: '有新版本可用',
  message: '我们刚刚发布了新版本,刷新页面以获取最新功能与修复。',
  reload: '立即刷新',
  snooze: '稍后',
}

export default versionUpdate
